import { Outlet, createFileRoute, notFound } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { DealPage, dealQuery } from '@/features/deals';
import { NotFoundView } from '@/features/shell';
import { isApiError } from '@/shared/api';

export const Route = createFileRoute('/_app/deals/$dealId')({
  staticData: { crumb: 'nav.deals', crumbTo: '/deals' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'deal.view', 'Deals'),
  loader: async ({ context, params }) => {
    try {
      const deal = await context.queryClient.query({ ...dealQuery(params.dealId), staleTime: 'static' });
      return { crumb: deal.number };
    } catch (e) {
      if (isApiError(e) && e.isNotFound) throw notFound();
      throw e;
    }
  },
  notFoundComponent: function DealNotFound() {
    const { dealId } = Route.useParams();
    return <NotFoundView reference={dealId} />;
  },
  component: function Deal() {
    const { dealId } = Route.useParams();
    return (
      <DealPage dealId={dealId}>
        <Outlet />
      </DealPage>
    );
  },
});
